// src/components/PeajesPage/PeajesPage.js
import React, { useState } from 'react';
import './PeajesPage.css';

// Datos de los peajes extraídos de las imágenes
const peajesData = [
  {
    nombre: 'MACHETÁ',
    detalles: {
      'Tipo Sentido': 'Bidireccional',
      'Peaje electrónico': 'Si',
      'Longitud': '5.077249',
      'Latitud': '-73.553398',
      'Sentidos': 'Sisga a Aguaclara - Aguaclara a Sisga',
      'Departamento - Municipio': 'Cundinamarca - Machetá',
      'Ubicación (PR/K)': 'PR 27 + 240.000',
      'Unidad funcional': 'UF 1 Sisga - Guateque',
      'Fecha inicio operación': '18/04/2016'
    }
  },
  {
    nombre: 'SAN LUIS DE GACENO',
    detalles: {
      'Tipo Sentido': 'Bidireccional',
      'Peaje electrónico': 'Si',
      'Longitud': '4.82556',
      'Latitud': '-73.083497',
      'Sentidos': 'Aguaclara - San Luis de Gaceno',
      'Departamento - Municipio': 'Boyacá - San Luis de Gaceno',
      'Ubicación (PR/K)': 'PR 76 + 990.000',
      'Unidad funcional': 'UF 4 Santa María - Aguaclara',
      'Fecha inicio operación': '10/11/2023'
    }
  }
];

const PeajesPage = () => {
  const [peajeActivo, setPeajeActivo] = useState(peajesData[0].nombre); // El primero abierto por defecto

  const handleTogglePeaje = (nombrePeaje) => {
    if (peajeActivo === nombrePeaje) {
      setPeajeActivo(null); // Si se hace clic en el mismo, se cierra
    } else {
      setPeajeActivo(nombrePeaje); // Si se hace clic en otro, se abre
    }
  };

  return (
    <div className="peajes-wrapper">
      <div className="peajes-header">
        <h2>Peajes del Corredor</h2>
      </div>
      <div className="peajes-container">
        {/* --- Columna ÚNICA de Información de Peajes --- */}
        <div className="info-peajes-columna">
          <div className="acordeon-container">
            {peajesData.map((peaje) => (
              <div key={peaje.nombre} className="acordeon-item">
                <div className="acordeon-header" onClick={() => handleTogglePeaje(peaje.nombre)}>
                  <span>{peaje.nombre}</span>
                  <span className={`acordeon-icono ${peajeActivo === peaje.nombre ? 'open' : ''}`}>▼</span>
                </div>
                <div className={`acordeon-content ${peajeActivo === peaje.nombre ? 'open' : ''}`}>
                  <div className="detalles-grid">
                    {Object.entries(peaje.detalles).map(([key, value]) => (
                      <div key={key} className="detalle-item">
                        <strong>{key}</strong>
                        <span>{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* --- Columna del Mapa Eliminada --- */}
      </div>
    </div>
  );
};

export default PeajesPage;